<div class="content-logo">
  <img proLogoImg alt="logo" class="content-logo__logo">
</div>
<div class="container">
  <div class="container-div">
    <h2 class="title">{{ 'signaturit_pro.scrivener_loi.title_tycs' | translate:_transParam }}</h2>
    <div class="mat__card">
      <p class="label-terms">{{ 'signaturit_pro.document.accept_consents' |
        translate:_transParam }}</p>
      <div class="card-div">
        <div class="card-div_tyc">
          <ng-container *ngIf="customConsents.length > 0">
            <div *ngFor="let c of customConsents" class="viewer__footer--contentCheck">
              <mat-checkbox class="checkbox" [checked]="c.checked"
                (change)="onChangeConsents($event.checked, c.id)">{{c.text}}</mat-checkbox>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="content__actions">
        <signaturit-button class="customBtn" text="{{ 'signaturit_pro.intro.button' | translate:_transParam }}"
          type="primary" size="md" [disabled]="!isAcceptAllConsents || disableAcceptButton" (click)="onNavigate()" [showLoader]="disableAcceptButton">
        </signaturit-button>
      </div>
    </div>
  </div>
</div>

